<template>
  <div>
    <p>Client {{ clientInfo.displayname }} est en cours de creation</p>
  </div>
</template>

<script>
export default {
  name: "InfoCreatingClient",

  props: {
    clientInfo: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped></style>
